// packages/ui/src/styles/transparencyCheckerboardSx.ts

/** The two squares of the checkerboard, light enough that a dark mark and a light one both show on it. */
const CHECK_LIGHT = '#ffffff';
const CHECK_DARK = '#d9d9d9';

/**
 * The ground of an uploaded image wherever it is viewed: the grey-and-white checkerboard an image editor shows
 * behind transparency, so a PNG or WebP with a transparent background is seen as transparent, never on black (asked
 * by the owner on 2026-10-14). Opaque images cover it entirely. Put it on the `<img>` itself, so only the image's
 * own area is checked. Plain CSS properties: it is MUI `sx` (`as const` keeps it assignable in the array form,
 * `sx={[transparencyCheckerboardSx, { … }]}`) and a React `style` alike (react-easy-crop's `mediaStyle`).
 */
export const transparencyCheckerboardSx = {
  backgroundColor: CHECK_LIGHT,
  backgroundImage: `repeating-conic-gradient(${CHECK_DARK} 0% 25%, ${CHECK_LIGHT} 0% 50%)`,
  backgroundSize: '16px 16px',
} as const;
